import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { SystemsPage } from '@/components/features/systems/SystemsPage';

const systemsSearchSchema = z.object({
  search: z.string().optional().catch(undefined),
  connector: z.array(z.string()).optional().catch(undefined),
  failed: z.boolean().optional().catch(undefined),
  // Only 'grid' exists today; the enum widens when the topology view lands.
  view: z.enum(['grid']).optional().catch(undefined),
  open: z.string().optional().catch(undefined),
  tab: z.enum(['overview', 'configuration', 'activity']).optional().catch(undefined),
  diagnose: z.boolean().optional().catch(undefined),
  signin: z.boolean().optional().catch(undefined),
});

export type SystemsSearch = z.infer<typeof systemsSearchSchema>;

export const Route = createFileRoute('/_protected/t/$tenantId/systems/')({
  component: SystemsPage,
  validateSearch: systemsSearchSchema,
});
